module.exports = __webpack_public_path__ + "img/ufa-service-hub-wide-night-v5.cf1c101d.webp";